<script setup>
import { PencilIcon } from "lucide-vue-next";

const modelValue = defineModel("modelValue");

const props = defineProps({
    placeholder: {
        type: String,
        default: "",
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    rows: {
        type: Number,
        default: 2,
    },
});
</script>
<template>
    <div class="relative group">
        <textarea
            :placeholder="placeholder"
            :rows="rows"
            :value="modelValue"
            @input="modelValue = $event.target.value"
            :readonly="readonly"
            :class="[
                'w-full block py-0.5 text-xs leading-5 text-gray-900 bg-transparent border-t-0 border-r-0 border-b border-l-0 border-gray-300 ring-0 dark:text-white dark:border-gray-800 dark:placeholder:text-gray-400 placeholder:text-gray-400',
                !readonly ? 'pr-7 pl-0 dark:focus:border-gray-700 focus:border-gray-950' : 'px-0 dark:focus:border-gray-800 focus:border-gray-300',
            ]" />
        <div v-if="!readonly" class="absolute inset-y-0 right-0 flex items-center pointer-events-none">
            <PencilIcon class="size-4 text-gray-600 dark:text-gray-400 dark:group-hover:text-white group-hover:text-gray-900" />
        </div>
    </div>
</template>
